import listActions from 'src/modules/tercero/list/terceroListActions';
import TerceroService from 'src/modules/tercero/terceroService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'TERCERO_DESTROY';

const terceroDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: terceroDestroyActions.DESTROY_STARTED,
      });

      await TerceroService.destroyAll([id]);

      dispatch({
        type: terceroDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.tercero.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/tercero');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: terceroDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: terceroDestroyActions.DESTROY_ALL_STARTED,
      });

      await TerceroService.destroyAll(ids);

      dispatch({
        type: terceroDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.tercero.destroyAll.success'),
      );

      getHistory().push('/tercero');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: terceroDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default terceroDestroyActions;
